import { TChatMessage, IChatCompletionAssistantMessageParam, IChatCompletionMessageFunctionToolCall } from 'extra/types/Messages'


export class MessageUtils {
  public static hasToolCall (message: TChatMessage): message is IChatCompletionAssistantMessageParam & {
    tool_calls: Array<IChatCompletionMessageFunctionToolCall>
  } {
    // only assistant messages can have tool calls
    return message.role === 'assistant' && (message.tool_calls?.length || 0) > 0
  }

  public static isString (message: TChatMessage | null | undefined): message is IChatCompletionAssistantMessageParam & {
    content: string
  } {
    return !!message && typeof message.content === 'string'
  }
}